import { STATUS_CONFIG } from '../pages/dsn-list/constants/dsntable.constants';
import {
  STATUS_GROUP_MAPPING,
  NATURE_MAPPING,
  TYPE_MAPPING,
  StatusConfig,
  StatusConfigKey,
} from '../types/dsn.types';

const STATUS_DETAIL_LABELS: Record<string, string> = {
  PartnerConformant: 'Reçu par le portail',
  AcceptedByDestination: 'Accepté par le destinataire',
  TransformedByEdiPartner: 'Transformé par le portail',
  PostedToDestination: 'Posté au destinataire',
  AcknowledgedByDestination: 'Accusé par le destinataire',
  AuthorizedBySage: 'Autorisé par Sage',
  InProgressWithAcceptance: 'En cours de traitement',
  RejectedBySage: 'Rejeté par Sage',
  TransformationFailed: 'Échec de transformation',
  NonConformantEdi: 'Non conforme EDI',
  NonConformantFormat: 'Format non conforme',
  NonConformantData: 'Données non conformes',
  NonConformantVersion: 'Version non conforme',
  EdiRejectedByDestination: 'Rejeté par le destinataire',
  EdiPartnerSendError: "Erreur d'envoi par le portail",
  CanceledByEdiPartner: 'Annulé par le portail',
  NonConformantAuthorization: 'Autorisation non conforme',
  PartlyRejected: 'Partiellement rejeté',
  InProgressWithErrors: 'En cours avec erreurs',
  UnexpectedDeclaration: 'Déclaration inattendue',
  SageSendError: "Erreur d'envoi par Sage",
  CommunicationWithDestinationFailed: 'Échec de communication avec le destinataire',
  NonConformantXslTransformation: 'Transformation XSL non conforme',
  RejectOrAnomaly: 'Rejet ou anomalie',
};

export const mapEdiStatusToUIStatus = (backendStatus: string): StatusConfigKey | undefined => {
  for (const [uiStatus, backendStatuses] of Object.entries(STATUS_GROUP_MAPPING)) {
    if (Array.isArray(backendStatuses) && backendStatuses.includes(backendStatus)) {
      return uiStatus as StatusConfigKey;
    }
  }

  return undefined;
};

export const mapStatusUIItem = (status: string | undefined): StatusConfig => {
  if (!status) {
    return {
      icon: 'help',
      color: 'var(--colorsGrey500)',
      label: 'Statut indéfini',
      pillVariant: 'grey',
    };
  }

  const statusKey = mapEdiStatusToUIStatus(status);

  if (!statusKey) {
    return {
      icon: 'help',
      color: 'var(--colorsGrey500)',
      label: 'Statut inconnu',
      pillVariant: 'grey',
    };
  }

  return STATUS_CONFIG[statusKey];
};

export const mapStatusDetailUIItem = (status: string | undefined): StatusConfig => {
  const statusUIItem = mapStatusUIItem(status);

  return {
    ...statusUIItem,
    label: status ? (STATUS_DETAIL_LABELS[status] ?? statusUIItem.label) : statusUIItem.label,
  };
};

export const mapNatureToDisplay = (nature: string): string => {
  return NATURE_MAPPING[nature] || nature;
};

export const mapTypeLabelToDisplay = (type: string): string => {
  return TYPE_MAPPING[type] || type;
};
